import type { FieldSchema } from '../shared/desktop-api';

const singleLineKinds = new Set([
  'document-type',
  'text',
  'identifier',
  'date',
  'date-time',
  'currency',
  'number',
  'integer',
  'decimal',
  'percentage',
  'phone',
  'email',
  'barcode',
]);

/** Only explicit page-text assignment changes whitespace. Copy and ordinary
 * typing keep their source strings; encoded barcode values bypass this helper.
 * Postal addresses are the schema's multiline kind. Existing value newlines,
 * multiple-value flags and example formats do not redefine a field's kind.
 * Unknown kinds remain untouched rather than guessing their layout contract. */
export function selectedTextForField(text: string, field: Pick<FieldSchema, 'kind'>): string {
  return singleLineKinds.has(field.kind) ? text.replace(/\s+/gu, ' ').trim() : text;
}
